import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import UserModel from '../../../domain/model/user_model';

export const    GetUserStatus = Object.freeze({
    initial: "initial",
    ongoing: "ongoing",
    complete: "complete",
});

export const createUserSlice = (userRepository) => {
    return createSlice({
        name: "user",
        initialState: {
            user: null,
            getUserStatus: GetUserStatus.initial,
        },
        reducers: {
            setGetUserStatusToInitial(state) {
                state.getUserStatus = GetUserStatus.initial;
            },
            logout(state) {
                state.getUserStatus = GetUserStatus.initial;
                state.user = null;
                userRepository.logout();
            }
        },
        extraReducers: (builder) => {
            builder
                .addCase(getUser.pending, (state) => {
                    state.getUserStatus = GetUserStatus.ongoing;
                })
                .addCase(getUser.fulfilled, (state, action) => {
                    state.getUserStatus = GetUserStatus.complete;
                    state.user = action.payload?.toJSON() ?? null;
                })
        },
    });
};

export const getUser = createAsyncThunk(
    "user/getUser",
    async (credentials, { rejectWithValue, extra }) => {
        const userRepository = extra.userRepository;
        const result = await userRepository.getUser();
        return result;
    }
);